import React from 'react';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddTiTe2 = ({styles, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Tipo de Tecnología nuevo
      </button>
        <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Código</label>
                  <input style={styles.input} autoComplete="off" name="codigoTipoTec" id="codigoTipoTec" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoTipoTec'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <input style={styles.input} autoComplete="off" name="descrTipoTec" id="descrTipoTec" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrTipoTec'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>

                <Divider inverted />

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddTiTe2
